import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    minWidth: 560,
    maxHeight: '60vh',
    overflowY: 'auto'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 0',
    borderBottom: '1px solid #e0e0e0'
  },
  // Dimmed, never hidden: a sender someone deliberately turned off is information.
  rowDisabled: {
    opacity: 0.55
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0
  },
  value: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  label: {
    color: '#6b7280'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginLeft: 'auto'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    paddingTop: 8
  },
  formRow: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start'
  },
  field: {
    flex: 1
  },
  empty: {
    color: '#6b7280',
    padding: '8px 0'
  },
  typeLabel: {
    color: '#6b7280'
  },
  // Explicit next to the dimming, so the state is announced and not only implied by opacity.
  disabledLabel: {
    color: '#6b7280',
    fontWeight: 600
  },
  trustNote: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '10px 12px',
    borderRadius: '8px',
    backgroundColor: 'rgba(31, 110, 134, 0.08)',
    marginBottom: '4px'
  },
  suggestions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: 'rgba(31, 110, 134, 0.06)',
    marginBottom: '8px'
  },
  suggestionsHead: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  suggestionsTitle: {
    fontWeight: 600
  },
  suggestionRow: {
    margin: 0,
    alignItems: 'flex-start'
  },
  suggestionText: {
    display: 'flex',
    flexDirection: 'column'
  },
  suggestionMeta: {
    fontSize: '12px',
    opacity: 0.65
  },
  suggestionsActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '4px',
    flexWrap: 'wrap'
  }
});
export default useStyles;